import { render, staticRenderFns } from "./PurchaseOrderEdit.vue?vue&type=template&id=b3a404d6&scoped=true&"
import script from "./PurchaseOrderEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a404d6",
  null
  
)

export default component.exports